module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-11"
  }, [_c('article', {
    staticClass: "card table-card"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-content is-paddingless"
  }, [_c('b-table', {
    attrs: {
      "data": _vm.expensesWaiting.data,
      "striped": true,
      "narrowed": false,
      "mobile-cards": false,
      "loading": _vm.expensesWaiting.isLoading,
      "row-class": _vm.getRowClass
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "label": "Nome"
          }
        }, [_vm._v(_vm._s(props.row.name))]), _c('b-table-column', {
          attrs: {
            "label": "Tipo"
          }
        }, [_vm._v(_vm._s(props.row.type))]), _c('b-table-column', {
          attrs: {
            "label": "Valor"
          }
        }, [_vm._v(_vm._s(_vm._f("currency")(props.row.value)))]), _c('b-table-column', {
          class: {
            'has-text-danger': props.row.due_date <= _vm.today
          },
          attrs: {
            "label": "Data Vencimento"
          }
        }, [_vm._v(_vm._s(_vm._f("moment")(props.row.due_date, 'DD/MM/YYYY')))]), _c('b-table-column', {
          attrs: {
            "label": "Status Análise"
          }
        }, [_c('b-tag', {
          attrs: {
            "type": _vm.statusClass[props.row.payment.status]
          }
        }, [_vm._v(_vm._s(_vm.statusLabel[props.row.payment.status]))])], 1), _c('b-table-column', {
          attrs: {
            "centered": "centered",
            "label": "Gerenciar Pagamento"
          }
        }, [_c('b-tooltip', {
          attrs: {
            "label": "Alterar Pagamento da Despesa",
            "type": "is-dark"
          }
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'paymentExpenseEdit',
              params: {
                id: props.row._id
              }
            }
          }
        }, [_c('span', [_vm._v("   "), _c('b-icon', {
          attrs: {
            "icon": "edit",
            "type": "is-primary",
            "size": "is-small"
          }
        })], 1)])], 1)], 1), _c('b-table-column', {
          attrs: {
            "centered": "centered",
            "label": "Gerenciar Despesa"
          }
        }, [_c('b-tooltip', {
          attrs: {
            "label": "Alterar Despesa",
            "type": "is-dark"
          }
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'expenseEdit',
              params: {
                id: props.row._id
              }
            }
          }
        }, [_c('span', [_vm._v("   "), _c('b-icon', {
          attrs: {
            "icon": "edit",
            "type": "is-primary",
            "size": "is-small"
          }
        })], 1)])], 1)], 1)]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c('p', [_c('b-icon', {
    attrs: {
      "icon": "sentiment_very_dissatisfied",
      "size": "is-large"
    }
  })], 1), _c('p', [_vm._v("Nenhum dado.")])])])])], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._v("Despesas Aguardando Aprovação a Vencer")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30472f9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/components/ExpensesWaiting.vue
// module id = 395
// module chunks = 56